import React, { useState, useEffect, useRef, useMemo } from "react";
import "../CurrentAffairs.css";
import {
  fetchCurrentAffairById,
  fetchPrevNextCurrentAffair,
} from "../services/CurrntAffairs";
import { ViewCurrentAffairById } from "../services/trendingService";
import searchMcqs from "../services/mcqSearchService";
import { markCurrentAffairAsRead } from "../services/trendingService";
import Header from "./Header";
import RelatedTopic from "./RelatedTopics";
import Keyword from "./Keyword";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import ChatInput from "./ChatInput";
import { parse, use } from "marked";
import Tooltip from "./CustomTooltip";
import html2pdf from "html2pdf.js";
import watermarkImage from "../assets/images/logo/SVG/Logo-Org.svg";
import SpeechButton from "./SpeechButton";
import { getRelatedSummaries } from "../services/relatedTopicsService";
import share from "../assets/images/share.svg";
import { useParams } from "react-router-dom";
import { getSuggestedQuestions } from "../services/getSuggestedQuestions";
import context from "react-bootstrap/esm/AccordionContext";
import { createMyNote, getMyNotesSubjects } from "../services/myNotesService";
import { createCurrentAffairsSelectionNoteDraft } from "../utils/myNotes";
import { getFirstItemsHeight } from "../utils/listScrollHeight";
import NoteToast from "./MyNotes/NoteToast";
import EditNoteModal from "./MyNotes/EditNoteModal";
function CurrentAffairs({ Check, isSidebarColl }) {
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [prevnext, setPrevnext] = useState({});
  const [buttonclicked, setbuttonclicked] = useState("");
  const { idd } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relatedSummariesData, setRelatedSummariesData] = useState(null);
  const [relatedSummariesLoader, setRelatedSummariesLoader] = useState(false);
  const [showPromptType, setShowPromptType] = useState(true);
  const [isdropdownVisibl, setdropdownVisibl] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({
    text: "Generic",
    image: "summarise.svg",
  });
  const [keywordsList, setKeywordsList] = useState([]);
  const [topicKeyword, setTopicKeyword] = useState("");
  const [questionsMap, setQuestionsMap] = useState({});
  const [sqListHeight, setSqListHeight] = useState(null);
  const [isMCQVisible, setMCQVisible] = useState(false);
  const [isEvaluateVisible, setEvaluateVisible] = useState(false);
  const [defaultText, setDefaultText] = useState("");
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const chatInputRef = useRef(null);
  const sqListRef = useRef(null);
  const speechButtonRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const { id, currentAffair } = location.state || {}; // fallback if state is undefined
  const shareUrl = `${window.location.origin}/currentaffairs/${id ? id : idd}`;
  const [sharePopupPos, setSharePopupPos] = useState({ top: 0, left: 0 });
  const [popup, setPopup] = useState({ visible: false, x: 0, y: 0, text: "" });
  const [editNoteDraft, setEditNoteDraft] = useState(null);
  const [showEditNoteModal, setShowEditNoteModal] = useState(false);
  const [isSavingEditNote, setIsSavingEditNote] = useState(false);
  const [noteSubjects, setNoteSubjects] = useState([]);
  const [noteToastMessage, setNoteToastMessage] = useState("");
  const [noteToastVariant, setNoteToastVariant] = useState("success");
  const [selectedSubject, setSelectedSubject] = useState("");
  const clampPopupToViewport = (x, y) => {
    const margin = 12;
    const safeX = Math.min(Math.max(x, margin), window.innerWidth - margin);
    const safeY = Math.min(Math.max(y, margin), window.innerHeight - margin);
    return { x: safeX, y: safeY };
  };

  const [isMainsPracticeVisible, setIsMainsPracticeVisible] = useState(false);

  const [isPrelims, setIsPrelims] = useState(false);
  const [message, setMessage] = useState("");


  useEffect(() => {
    const fetchSuggestedQuestions = async () => {
      try {
        const suggestedQuestions = await getSuggestedQuestions(
          keywordsList,
          "",
          data?.topic,
        );
        setQuestionsMap(suggestedQuestions);

        // Do something with suggestedQuestions, e.g., update state
      } catch (error) {
        console.error("Error fetching suggested questions:", error);
      } finally {
      }
    };
    if (keywordsList.length > 0) fetchSuggestedQuestions();
  }, [keywordsList, data?.topic]);

  const handleTextSelect = (e) => {
    const selection = window.getSelection();
    const selectedText = selection?.toString().trim() || "";
    const getSelectionStartRect = () => {
      if (!selection?.rangeCount || !selection.anchorNode) {
        return null;
      }

      try {
        const anchorRange = document.createRange();
        const anchorNode = selection.anchorNode;
        const maxOffset =
          anchorNode.nodeType === Node.TEXT_NODE
            ? anchorNode.textContent?.length || 0
            : anchorNode.childNodes?.length || 0;
        const safeOffset = Math.min(selection.anchorOffset || 0, maxOffset);

        anchorRange.setStart(anchorNode, safeOffset);
        anchorRange.setEnd(anchorNode, safeOffset);

        const anchorRect = anchorRange.getBoundingClientRect();
        if (anchorRect && (anchorRect.width || anchorRect.height)) {
          return anchorRect;
        }
      } catch (error) {
        // Fallback to selected range below.
      }

      return selection.getRangeAt(0).getBoundingClientRect();
    };

    if (selectedText && selection?.rangeCount > 0) {
      const rect = getSelectionStartRect();
      if (!rect) {
        return;
      }

      const popupPoint = clampPopupToViewport(
        rect.left + rect.width / 2,
        rect.top - 12,
      );
      setPopup({
        visible: true,
        x: popupPoint.x,
        y: popupPoint.y,
        text: selectedText,
      });
    }
  };

  const handleDocumentSelectionEnd = (event) => {
    const selection = window.getSelection();
    const selectedText = selection?.toString().trim() || "";
    const getSelectionStartRect = () => {
      if (!selection?.rangeCount || !selection.anchorNode) {
        return null;
      }

      try {
        const anchorRange = document.createRange();
        const anchorNode = selection.anchorNode;
        const maxOffset =
          anchorNode.nodeType === Node.TEXT_NODE
            ? anchorNode.textContent?.length || 0
            : anchorNode.childNodes?.length || 0;
        const safeOffset = Math.min(selection.anchorOffset || 0, maxOffset);

        anchorRange.setStart(anchorNode, safeOffset);
        anchorRange.setEnd(anchorNode, safeOffset);

        const anchorRect = anchorRange.getBoundingClientRect();
        if (anchorRect && (anchorRect.width || anchorRect.height)) {
          return anchorRect;
        }
      } catch (error) {
        // Fallback to selected range below.
      }

      return selection.getRangeAt(0).getBoundingClientRect();
    };

    if (!selectedText || !selection?.rangeCount) {
      if (!event?.target?.closest?.(".text-selection-popup")) {
        setPopup({ visible: false, x: 0, y: 0, text: "" });
      }
      return;
    }

    const range = selection.getRangeAt(0);
    const anchorElement = selection.anchorNode?.parentElement;
    const focusElement = selection.focusNode?.parentElement;
    const startElement = range.startContainer?.parentElement;
    const endElement = range.endContainer?.parentElement;

    const isInsideCurrentAffairs =
      anchorElement?.closest(".curren-af-container") ||
      focusElement?.closest(".curren-af-container") ||
      startElement?.closest(".curren-af-container") ||
      endElement?.closest(".curren-af-container");

    if (!isInsideCurrentAffairs) {
      return;
    }

    const rect = getSelectionStartRect();
    if (!rect) {
      return;
    }
    const popupPoint = clampPopupToViewport(
      rect.left + rect.width / 2,
      rect.top - 12,
    );

    setPopup({
      visible: true,
      x: popupPoint.x,
      y: popupPoint.y,
      text: selectedText,
    });
  };
  useEffect(() => {
    if (popup.visible) {
      const handleClickOutside = (e) => {
        if (!e.target.closest(".text-selection-popup")) {
          setPopup({ visible: false, x: 0, y: 0, text: "" });
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [popup.visible]);

  useEffect(() => {
    if (!showSharePopup) return;

    const handleWindowClick = () => setShowSharePopup(false);

    window.addEventListener("click", handleWindowClick);
    window.addEventListener("scroll", handleWindowClick, true);

    return () => {
      window.removeEventListener("click", handleWindowClick);
      window.removeEventListener("scroll", handleWindowClick, true);
    };
  }, [showSharePopup]);

  useEffect(() => {
    const handleSelectionKeyUp = (event) => {
      const navigationKeys = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
        "PageUp",
        "PageDown",
      ];

      if (event.shiftKey && navigationKeys.includes(event.key)) {
        handleTextSelect();
      }
    };

    document.addEventListener("keyup", handleSelectionKeyUp);
    return () => {
      document.removeEventListener("keyup", handleSelectionKeyUp);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mouseup", handleDocumentSelectionEnd);
    return () => {
      document.removeEventListener("mouseup", handleDocumentSelectionEnd);
    };
  }, []);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      try {
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error("Failed to copy link:", fallbackErr);
        alert("Failed to copy link");
      }
    }
  };

  useEffect(() => {
    let cancelled = false;

    getMyNotesSubjects()
      .then((subjects) => {
        if (!cancelled) {
          setNoteSubjects(subjects);
        }
      })
      .catch((error) => {
        console.error("Failed to load note subjects", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const showNoteToast = (message, variant = "success") => {
    setNoteToastVariant(variant);
    setNoteToastMessage(message);
  };

  const handleAddSelectionToNotes = () => {
    if (!popup.text?.trim()) {
      return;
    }

    const selectedText = popup.text.trim();
    const noteDraft = createCurrentAffairsSelectionNoteDraft({
      title: data?.topic,
      selectedText,
    });
    const keywordTags = (keywordsList || []).filter(Boolean).map((k) => k.trim());
    noteDraft.tags = [...new Set([...noteDraft.tags, ...keywordTags])];

    setEditNoteDraft(noteDraft);
    setShowEditNoteModal(true);
    setPopup({ visible: false, x: 0, y: 0, text: "" });
  };

  const handleSaveWholeContext = () => {
    if (!data) return;

    const highlightsContent = data.highlights
      .map((h) =>
        parse(
          (h.highlight_text || "")
            .split("\n")
            .filter((line) => line.trim() !== "| **")
            .join("\n"),
          { breaks: true },
        ),
      )
      .join('\n\n');

    const noteDraft = {
      title: data.topic || "Current Affairs",
      content: `<div>${highlightsContent}</div>`,
      tags: ["Current Affairs"],
      attachments: [],
    };

    const keywordTags = (keywordsList || []).filter(Boolean).map((k) => k.trim());
    noteDraft.tags = [...new Set([...noteDraft.tags, ...keywordTags])];

    setEditNoteDraft(noteDraft);
    setShowEditNoteModal(true);
  };

  const handleEditNoteSave = async (noteData) => {
    setIsSavingEditNote(true);
    try {
      await createMyNote(noteData);
      setShowEditNoteModal(false);
      setEditNoteDraft(null);
      setPopup({ visible: false, x: 0, y: 0, text: "" });
      showNoteToast("Your note was saved successfully.");
    } catch (noteError) {
      console.error("Failed to create current affairs note:", noteError);
      showNoteToast("We could not save your note. Please try again.", "error");
    } finally {
      setIsSavingEditNote(false);
    }
  };

  const handleEditNoteClose = () => {
    setShowEditNoteModal(false);
    setEditNoteDraft(null);
  };

  function cleanText(text) {
    // Remove any text that starts with a square bracket and ends with a square bracket
    const question = text.replace(/\s*\[\d{4}.*?\]\s*/g, "").trim();
    return question;
  }
  const predefinedPrompts = [
    {
      label: "Model Answer",
      description: "To 'Why labor force...'",
      value: "Model Answer",
      image: "/assets/images/model-ans.svg",
    },
    {
      label: "Essay Guidance",
      description: "The ship in the harbor is safe, but...",
      value: "Essay Guidance",
      image: "/assets/images/eassy-guidance-new.svg",
    },
    {
      label: "Short Notes",
      description: "Short Notes on 'plate tectonics'",
      value: "Short Notes",
      image: "/assets/images/short-notes.svg",
    },
    {
      label: "Case Study",
      description: "Case Study on 'Digital Divide'",
      value: "Case Study",
      image: "/assets/images/cas-study2.svg",
    },
    {
      label: "Approach",
      description: "To 'Why labor force...'",
      value: "Approach",
      image: "/assets/images/approach1.svg",
    },
    {
      label: "PYQ Mains",
      description: "PYQs on Industrial Growth",
      value: "PYQ Mains",
      image: "/assets/images/model-ans.svg",
    },
    {
      label: "PYQ Prelims",
      description: "PYQs on Biodiversity",
      value: "PYQ Prelims",
      image: "/assets/images/info.svg",
    },
    {
      label: "Evaluate",
      description: "Why labor force participation",
      value: "Evaluate",
      image: "/assets/images/write-pad.svg",
    },
    {
      label: "Mains Practice",
      description: "On 'Why labor force...'",
      value: "Mains Practice",
      image: "/assets/images/write-pad.svg",
    },
  ];

  const calculateReadTime = (highlights) => {
    if (!highlights || highlights.length === 0) return "1 min";

    // Average reading speed (words per minute)
    const wordsPerMinute = 200;

    // Calculate total words across all highlights
    const totalWords = highlights.reduce((acc, highlight) => {
      // Create a temporary div to parse markdown and get plain text
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = parse(highlight.highlight_text);
      const plainText = tempDiv.textContent;
      // Count words in plain text
      return acc + (plainText.match(/\S+/g)?.length || 0);
    }, 0);

    // Calculate reading time in minutes, minimum 1 minute
    const minutes = Math.max(1, Math.ceil(totalWords / wordsPerMinute));
    return `${minutes}`;
  };

  const copyContent = (content) => {
    const textToCopy = content.highlights
      .map((h) => {
        // Create a temporary div to get the parsed HTML content
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = parse(h.highlight_text);
        // Get the text content without HTML tags
        return tempDiv.textContent;
      })
      .join("\n\n");

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy content: ", err);
      });
  };

  const generatePdf = (content) => {
    // Create a wrapper div for the content
    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";

    // Add title
    const titleDiv = document.createElement("div");
    titleDiv.style.fontWeight = "bold";
    titleDiv.style.marginBottom = "20px";
    titleDiv.style.fontSize = "16px";
    titleDiv.textContent = content.topic;
    wrapper.appendChild(titleDiv);

    // Add date
    const dateDiv = document.createElement("div");
    dateDiv.style.marginBottom = "20px";
    dateDiv.style.fontSize = "14px";
    dateDiv.textContent = `Date: ${new Date(
      content.ca_created_date,
    ).toLocaleDateString()}`;
    wrapper.appendChild(dateDiv);

    // Add content
    content.highlights.forEach((highlight) => {
      const contentDiv = document.createElement("div");
      contentDiv.innerHTML = parse(highlight.highlight_text);
      contentDiv.style.marginBottom = "20px";
      wrapper.appendChild(contentDiv);
    });

    // Configure PDF options
    const opt = {
      margin: 0.5,
      filename: `${content.topic
        .replace(/[^a-z0-9]/gi, "_")
        .toLowerCase()}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: "in",
        format: "letter",
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    // Generate PDF
    html2pdf()
      .set(opt)
      .from(wrapper)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const img = new Image();
        img.src = watermarkImage;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.globalAlpha = 0.2; // Set opacity
          ctx.drawImage(img, 0, 0, img.width, img.height);
          const imgBase64 = canvas.toDataURL("image/png");

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            const imgWidth = pageWidth * 0.2;
            const imgHeight = (img.height / img.width) * imgWidth;
            const xPos = (pageWidth - imgWidth) / 2;
            const yPos = (pageHeight - imgHeight) / 2;

            pdf.addImage(
              imgBase64,
              "PNG",
              xPos,
              yPos,
              imgWidth,
              imgHeight,
              null,
              "NONE",
            );
          }

          // Save the generated PDF
          pdf.save(opt.filename);
          setIsDownloaded(true);
          setTimeout(() => {
            setIsDownloaded(false);
          }, 2000);
        };
      })
      .catch((err) => {
        console.error("PDF generation failed:", err);
        alert("Error generating PDF. Please try again.");
      });
  };

  const monthRaw = localStorage.getItem("selectedMonths");
  const keywordsRaw = localStorage.getItem("selectedCategory");
  const yearRaw = localStorage.getItem("selectedYears"); // assuming year is also in localStorage

  const month = monthRaw ? JSON.parse(monthRaw) : [];
  let keywords = keywordsRaw
    ? JSON.parse(keywordsRaw)
        .split(/[\/&]/)
        .map((k) => k.trim())
        .filter(Boolean)
    : [];
  const years = yearRaw ? JSON.parse(yearRaw) : [];
  const handleQuestionClickSelect = (question, promptType) => {
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchCurrentAffairById(id ? id : idd);
        setData(response);
        setLoading(false);

        const keywordsList =
          response.keywords?.[0]?.kword?.split(",").map((k) => k.trim()) || [];
        setKeywordsList(keywordsList);
        setKeywordsList(keywordsList || []);

        const prevnext = await fetchPrevNextCurrentAffair({
          current_affair_id: Number(id || idd),
          keywords,
          years,
          months: month,
        });
        setPrevnext(prevnext);
        const data = await ViewCurrentAffairById(id ? id : idd);

        const isRead = await markCurrentAffairAsRead(id ? id : idd);

        setLoading(false);
      } catch (err) {
        setError(err.message || "Failed to fetch current affair");
        setLoading(false);
      } finally {
      }
    };

    // Stop any ongoing speech when data changes
    if (speechButtonRef.current && speechButtonRef.current.isSpeaking) {
      speechButtonRef.current.stopSpeech();
    }

    if (currentAffair) {
      setData(currentAffair);
      setLoading(false);
    } else if (id || idd) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [id, currentAffair, idd]);

  // Stop speech when component unmounts or navigates away
  useEffect(() => {
    return () => {
      if (speechButtonRef.current && speechButtonRef.current.isSpeaking) {
        speechButtonRef.current.stopSpeech();
      }
    };
  }, []);

  useEffect(() => {
    setRelatedSummariesLoader(true);
    const fetchSummaries = async () => {
      if (data?.topic) {
        try {
          const response = await getRelatedSummaries(
            keywordsList?.length == 0 ? [data.topic] : keywordsList,
          );
          setRelatedSummariesData(response.related_summaries || []);
          setRelatedSummariesLoader(false);
        } catch (err) {
          setRelatedSummariesLoader(false);
          console.error("Error fetching related summaries:", err);
        } finally {
          setRelatedSummariesLoader(false);
        }
      }
    };

    fetchSummaries();
  }, [data]);

  const showSqScroll = (questionsMap?.matches?.length || 0) > 3;

  // Size the PYQ list to exactly three visible questions, then scroll.
  useEffect(() => {
    if (!showSqScroll) {
      setSqListHeight(null);
      return undefined;
    }

    let cancelled = false;
    const measure = () => {
      if (cancelled) return;
      setSqListHeight(getFirstItemsHeight(sqListRef.current, 3));
    };

    measure();
    window.addEventListener("resize", measure);
    if (document.fonts?.ready) {
      document.fonts.ready.then(measure).catch(() => {});
    }

    return () => {
      cancelled = true;
      window.removeEventListener("resize", measure);
    };
  }, [showSqScroll, questionsMap]);

  const handlePromptSelect = (promptType) => {
    if (chatInputRef.current) {
      chatInputRef.current.handleSelectPrompt(promptType, "");
      setSelectedPrompt({ text: promptType, image: "summarise.svg" });
    }
  };

  const handleStartTest = async (topic) => {
    try {
      const messageText = `Give me MCQ questions for ${topic}`;
      const mcqData = await searchMcqs(topic);
      handleSend({
        message: messageText,
        prompt: "Prelims Practice",
        mcqData: {
          questions: mcqData,
          subjectId: null,
          topicId: null,
          subtopicId: null,
          numQuestions: String(mcqData?.length || 0),
        },
      });
    } catch (error) {
      console.error("Error starting test:", error);
      // Optional: show a fallback alert or toast
    }
  };
  const handleStartModeltest = async (question) => {
    //     const mapping = {
    //   essay: "Frame Your Essay",
    //   short_note: "Quick Topic Summary",
    //   case_study: "Explore a Case Study",
    //   generic: "Generic",
    //   answer: "See a Model Answer",
    //   approach: "Plan Your Answer",
    // };
    setSelectedPrompt({ text: "See a Model Answer", image: "summarise.svg" });
    handleSend({
      message: question,
      prompt: "See a Model Answer",
      mcqData: null,
    });
    // try {
    //   const messageText = `Give me MCQ questions for ${topic}`;
    //         const mcqData = await searchMcqs(topic, 5);
    //   handleSend({
    //     message: messageText,
    //     prompt: "Prelims Practice",
    //     mcqData: {
    //         questions: mcqData,
    //         subjectId: null,
    //         topicId: null,
    //         subtopicId: null,
    //         numQuestions: "5",
    //       },
    //   });
    // } catch (error) {
    //   console.error("Error starting test:", error);
    //   // Optional: show a fallback alert or toast
    // }
  };

  const handleSend = ({ message, prompt, mcqData, mainsPractice }) => {
    if (!message) return;
    // const mapping = {
    //   Essay: "essay",
    //   "Essay Guidance": "essay",
    //   "Model Answer": "answer",
    //   Answer: "answer",
    //   Approach: "approach",
    //   "Case Study": "case_study",
    //   "Short Notes": "short_note",
    //   Generic: "",
    // };

    const mapping = {
      Essay: "essay",
      "Frame Your Essay": "essay",
      "See a Model Answer": "answer",
      Answer: "answer",
      "Plan Your Answer": "approach",
      "Explore a Case Study": "case_study",
      "Quick Topic Summary": "short_note",
      Generic: "",
    };
    //   const mapping = {
    //   essay: "Frame Your Essay",
    //   short_note: "Quick Topic Summary",
    //   case_study: "Explore a Case Study",
    //   generic: "Generic",
    //   answer: "See a Model Answer",
    //   approach: "Plan Your Answer",
    // };


    if (prompt === "Prelims Practice") {
      // Create initial messages array with current affair content first, then user message
      const initialMessages = [
        {
          sender: "bot",
          message:
            `<h2 class="curren-af-title">${data.topic}</h1>\n\n` +
            data.highlights
              .map((highlight) => parse(highlight.highlight_text))
              .join("\n\n"),
          prompt: "",
          topic: data?.topic,
          keywords: null,
          caseStudies: null,
          initiatives: null,
        },
        {
          sender: "user",
          message: message,
          prompt: "Prelims Practice",
          mcqData: mcqData,
        },
        {
          sender: "bot",
          message: message,
          context: "Current Affairs",
          prompt: "Prelims Practice",
          mcqData: mcqData,
          topic: null,
          keywords: null,
          caseStudies: null,
          initiatives: null,
        },
      ];
      // console.log("Initial Messages:", initialMessages);

      // Navigate to ChatWindow with initial messages
      navigate(ROUTES.CHAT, {
        state: {
          initialMessages,
          flag: true,
        },
      });
    } else if (prompt === "Mains Practice") {
      // Create initial messages array with current affair content first, then user message
      const initialMessages = [
        {
          sender: "bot",
          message:
            `<h2 class="curren-af-title">${data.topic}</h1>\n\n` +
            data.highlights
              .map((highlight) => parse(highlight.highlight_text))
              .join("\n\n"),
          prompt: "",
          topic: data?.topic,
          keywords: null,
          caseStudies: null,
          initiatives: null,
        },
        {
          sender: "user",
          message: message,
          prompt: "Mains Practice",
          mainsPractice: mainsPractice,
        },
        {
          sender: "bot",
          message: message,
          context: "Current Affairs",
          prompt: "Mains Practice",
          mainsPractice: mainsPractice,
          topic: null,
          keywords: null,
          caseStudies: null,
          initiatives: null,
        },
      ];
      // console.log("Initial Messages:", initialMessages);

      // Navigate to ChatWindow with initial messages
      navigate(ROUTES.CHAT, {
        state: {
          initialMessages,
          flag: true,
        },
      });
    } else {
      // Create initial messages array with current affair content first, then user message
      const initialMessages = [
        {
          sender: "bot",
          message:
            `<h2 class="curren-af-title">${data.topic}</h2>\n\n` +
            data.highlights
              .map((highlight) => parse(highlight.highlight_text))
              .join("\n\n"),
          prompt: "",
          promptType: mapping[prompt],
          topic: data?.topic,
          keywords: null,
          caseStudies: null,
          initiatives: null,
          context: data.highlights
            .map((highlight) => parse(highlight.highlight_text))
            .join("\n\n"),
          keywordsArray: keywordsList || [],
        },
        {
          sender: "user",
          message: message,
          prompt: prompt,
          promptType: mapping[prompt],
          context: "",
        },
      ];

      // Navigate to ChatWindow with initial messages
      navigate(ROUTES.CHAT, {
        state: {
          initialMessages,
          flag: true,
        },
      });
    }
  };

  if (loading) {
    return (
      <div className="current-af-parent">
        <Header
          message={[{ message: "Current Affairs" }]}
          Check={Check}
          isSidebarColl={isSidebarColl}
        />
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="current-af-parent">
        <Header
          message={[{ message: "Current Affairs" }]}
          Check={Check}
          isSidebarColl={isSidebarColl}
        />
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            margin: "20px",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dc3545",
            borderRadius: "8px",
          }}
        >
          <h3 style={{ color: "#dc3545", marginBottom: "10px" }}>{error}</h3>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 16px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="current-af-parent">
        <Header
          message={[{ message: "Current Affairs" }]}
          Check={Check}
          isSidebarColl={isSidebarColl}
        />
        <div className="current-af-parent-no-data">No data available</div>
      </div>
    );
  }

  return (
    <div className="current-af-parent">
      <Header
        message={[{ message: "Current Affairs" }]}
        Check={Check}
        isSidebarColl={isSidebarColl}
      />
      {popup.visible && (
        <div
          className="text-selection-popup"
          style={{
            position: "fixed",
            top: popup.y - 30,
            left: popup.x,
            transform: "translate(-50%, 0)",
            background: "white",
            // border: "1px solid #ddd",
            // padding: "6px 10px",
            borderRadius: "8px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            zIndex: 1000,
            display: "flex",
            gap: "8px",
          }}
          onMouseDown={(e) => e.stopPropagation()} // 👈 prevents closing popup
        >
          <button
            style={{
              outline: "none",
              border: "none",
              backgroundColor: "#007bff",
              color: "black",
              borderRadius: "4px",
              cursor: "pointer",
              background: "linear-gradient(90deg, #FFE8D9 0%, #FFFAF4 100%)",
              border: "1px solid #F5D5B1",
            }}
            onClick={() => {
              // handleQuestionClickSelect(popup.text, "Quick Topic Summary");
              handleSend({
                message: popup.text,
                prompt: "Quick Topic Summary",
                mcqData: null,
              });
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5855 14.3123C15.5855 18.5581 12.0966 22 7.79275 22C3.48893 22 0 18.5581 0 14.3123C0 10.0665 3.48893 6.62454 7.79275 6.62454C12.0966 6.62454 15.5855 10.0665 15.5855 14.3123ZM3.76964 14.3123C3.76964 16.5042 5.57085 18.2812 7.79275 18.2812C10.0146 18.2812 11.8158 16.5042 11.8158 14.3123C11.8158 12.1203 10.0146 10.3434 7.79275 10.3434C5.57085 10.3434 3.76964 12.1203 3.76964 14.3123Z"
                    fill="#F59C36"
                  />
                  <path
                    d="M9.56131 14.3123C9.56131 15.2759 8.7695 16.057 7.79275 16.057C6.81599 16.057 6.02418 15.2759 6.02418 14.3123C6.02418 13.3487 6.81599 12.5675 7.79275 12.5675C8.7695 12.5675 9.56131 13.3487 9.56131 14.3123Z"
                    fill="#F59C36"
                  />
                  <path
                    d="M16 0L9.56131 4.28005C12.9658 4.84709 15.1065 6.80628 15.7513 7.71499L16 0Z"
                    fill="#F59C36"
                  />
                </svg>
              </span>
              <p
                style={{
                  margin: "0px",
                  marginTop: "2px",
                }}
              >
                Askyooki
              </p>
            </div>
          </button>
          <button
            style={{
              outline: "none",
              border: "none",
              color: "black",
              borderRadius: "4px",
              cursor: "pointer",
              background: "linear-gradient(90deg, #D9F4FF 0%, #F4FCFF 100%)",
              border: "1px solid #B1E0F5",
            }}
            onClick={handleAddSelectionToNotes}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span>
                <img
                  src="../assets/images/my_notes_new_sidebar_active.svg"
                  alt="Save Notes"
                  height={25}
                  width={25}
                />
              </span>
              <p
                style={{
                  margin: "0px",
                  marginTop: "2px",
                  minWidth: "80px",
                }}
              >
                Save Notes
              </p>
            </div>
          </button>
        </div>
      )}
      <div className="curren-af-body">
        <div
          className={`curren-af-container ${
            buttonclicked == "" ? "" : "clicked-item"
          }`}
        >
          <h2 className="curren-af-title">{data?.topic}</h2>
          <div className="curren-af-meta">
            <div className="left-meta">
              <span className="curren-af-dot">
                <img
                  src="/assets/images/current-affairs-calender.svg"
                  alt="current-affairs-calender"
                />
              </span>
              <span className="curren-af-date">
                {data?.ca_created_date &&
                  new Date(data.ca_created_date)
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(/ /g, "-")}
              </span>
              <span className="curren-af-dot">
                <img
                  src="/assets/images/current-affairs-clock.svg"
                  alt="current-affairs-clock"
                />
              </span>
              <span className="curren-af-read">
                {data?.highlights ? calculateReadTime(data.highlights) : "1"}{" "}
                min read
              </span>
              <span className="curren-af-dot">
                <img
                  src="/assets/images/current-affairs-eye.svg"
                  alt="correct"
                />
              </span>
              <span className="curren-af-views">{data?.view_count}</span>
            </div>
            <div className="right-meta">
              <SpeechButton
                ref={speechButtonRef}
                content={data}
                size={20}
                showTimer={false}
              />
            </div>
          </div>
          {data?.highlights?.map((highlight, index) => (
            <div key={highlight?.id || index} className="highlight-container">
              <div
                className="prose prose-sm bg-red-100 mb-6"
                onMouseUp={handleTextSelect}
                dangerouslySetInnerHTML={{
                  __html: parse(
                    (highlight?.highlight_text || "")
                      .split("\n")
                      .filter((line) => line.trim() !== "| **")
                      .join("\n"),
                    { breaks: true },
                  ),
                }}
              />
              <div className="left-copy-icon-div">
                <span className="copy-icon left-icon" onClick={() => copyContent(data)}>
                  <img src="/assets/images/Copy1.svg" alt="copy" />
                  <span className="icon-text">Copy</span>
                </span>

                <span className="copy-icon left-icon" onClick={() => generatePdf(data)}>
                  <img src="/assets/images/download.svg" alt="download" />
                  <span className="icon-text">Download</span>
                </span>

                <a
                  href={data?.source?.split("\n")[0] || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="copy-icon left-icon"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={`https://www.google.com/s2/favicons?sz=64&domain_url=${data.source}`}
                    alt="source"
                    title="View Source"
                    width={20}
                    height={20}
                  />
                  <span className="icon-text">Source</span>
                </a>

                <span
                  className="copy-icon left-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    const rect = e.currentTarget.getBoundingClientRect();
                    setSharePopupPos({
                      top: rect.bottom + window.scrollY + 8,
                      left: rect.left + window.scrollX,
                    });
                    setShowSharePopup((prev) => !prev);
                    setCopied(false);
                  }}
                >
                  <img src={share} alt="share" />
                  <span className="icon-text">Share</span>
                </span>

                <span
                  className="copy-icon left-icon"
                  onClick={handleSaveWholeContext}
                >
                  <img src="/assets/images/note-2.svg" alt="save note" style={{width:"20px",height:"20px"}} />
                  <span className="icon-text">Save to My Notes</span>
                </span>

                <span className="action-messages">
                  {isCopied ? <span className="copied">Copied!</span> : null}
                  {isDownloaded ? <span className="copied">Downloaded!</span> : null}
                </span>
              </div>
            </div>
          ))}

          {/* <Keyword keywords={keywordsList.map(k => `<p class="keyword">${k}</p>`).join('')} /> */}

          {questionsMap?.matches?.length > 0 && (
            <div className="content-div px-0">
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <img
                    src="/assets/images/Follow-up-questions.svg"
                    alt="follow"
                  />
                  <span className="sq-title" style={{ marginLeft: "7px" }}>
                    Mains PYQs
                  </span>
                </div>
              </div>

              <div
                id="sq-res"
                ref={sqListRef}
                className={showSqScroll ? "sq-scroll" : undefined}
                style={
                  showSqScroll && sqListHeight
                    ? { maxHeight: `${sqListHeight}px` }
                    : undefined
                }
              >
                {questionsMap.matches.map((question) => (
                  <div
                    key={question.q_id}
                    className="suggested-questions mt-3"
                    onClick={() => {
                      handleStartModeltest(cleanText(question.qstn));
                    }}
                  >
                    <span className="btn-sq">
                      <span className="que-con question">
                        {cleanText(question.qstn)}
                      </span>

                      <span className="subject-year">
                        <span
                          className="que-con"
                          style={{ marginRight: "10px" }}
                        >
                          {question.subject}
                        </span>

                        <span className="que-con">{question.year}</span>
                      </span>
                    </span>

                    <div className="d-flex" style={{ alignItems: "center" }}>
                      <img
                        src="/assets/images/right-arrow.svg"
                        className="icon-prompt"
                        alt="Right arrow"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="post-nav">
            {/* Previous Post */}
            {prevnext?.previous && prevnext.previous !== "00" ? (
              <div
                className="post"
                onClick={() => {
                  navigate(`/currentaffairs/${prevnext["previous"]["id"]}`);
                }}
              >
                <img
                  src={prevnext?.previous?.images?.[0]?.image_url}
                  onError={(e) => {
                    e.currentTarget.src = "/assets/images/noimage.jpeg";
                  }}
                  alt="Previous Post"
                />
                <div className="post-content">
                  <div className="post-label">PREVIOUS POST</div>
                  <div className="post-title">
                    {prevnext["previous"]["topic"]}
                  </div>
                  <div className="post-date">
                    {new Date(
                      prevnext["previous"]["ca_created_date"],
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="post"></div>
            )}

            {/* Next Post */}
            {prevnext?.next && prevnext.next !== "00" ? (
              <div
                className="post reverse"
                onClick={() => {
                  navigate(`/currentaffairs/${prevnext["next"]["id"]}`);
                }}
              >
                <img
                  src={prevnext?.next?.images?.[0]?.image_url}
                  onError={(e) => {
                    e.currentTarget.src = "/assets/images/noimage.jpeg";
                  }}
                  alt="Next Post"
                />
                <div className="post-content">
                  <div className="post-label">NEXT POST</div>
                  <div className="post-title">{prevnext["next"]["topic"]}</div>
                  <div className="post-date">
                    {new Date(
                      prevnext["next"]["ca_created_date"],
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="post reverse"></div>
            )}
          </div>
        </div>
        <div className="right-sidebar-area RelatedTopic-mob related-curr-af">
          <RelatedTopic
            relatedSummariesData={relatedSummariesData}
            relatedSummariesLoader={relatedSummariesLoader}
            id={id}
            relatedTopicsData={[]}
            showpracticetest={keywordsList.length > 0}
            keywords={keywordsList}
            setTopicKeyword={setTopicKeyword}
            onStartTest={handleStartTest}
          />
        </div>
      </div>

      <div
        className="chatfiled chat-input-row chat-input-row-current-affairs"
        style={{ display: "flex" }}
      >
        <div className="main-content-area" style={{ flex: 1 }}>
          <div className="chat-input-container chat-input-container-current-affairs">
            <ChatInput
              showattachment={false}
              selectedSubject={selectedSubject}
              setMCQVisible={setMCQVisible}
              setIsMainsPracticeVisible={setIsMainsPracticeVisible}
              setEvaluateVisible={setEvaluateVisible}
              setDefaultText={setDefaultText}
              setIsPrelims={setIsPrelims}
              setMessage={setMessage}
              setSelectedPrompt={setSelectedPrompt}
              selectedPrompt={selectedPrompt}
              setSelectedSubject={setSelectedSubject}
              message={message}
              isPrelims={isPrelims}
              isMainsPracticeVisible={isMainsPracticeVisible}
              setbuttonclicked={setbuttonclicked}
              ref={chatInputRef}
              onSend={handleSend}
              isStreamingDone={true}
              setMsgSend={() => {}}
              setdropdownVisibl={setdropdownVisibl}
              isdropdownVisibl={isdropdownVisibl}
              showPromptType={showPromptType}
              setShowPromptType={setShowPromptType}
              setPromptType={handlePromptSelect}
              isMCQVisible={isMCQVisible}
              isEvaluateVisible={isEvaluateVisible}
              defaultText={defaultText}
              isDropdownVisible={isDropdownVisible}
              setDropdownVisible={setDropdownVisible}
            />
            <div className="chatwindow-textbox-below-msg">
              Yooki is AI and can make mistakes
            </div>
          </div>
        </div>
        <div className="right-sidebar-area RelatedTopic-mob"></div>
      </div>
      {showEditNoteModal && editNoteDraft && (
        <EditNoteModal
          note={editNoteDraft}
          isSaving={isSavingEditNote}
          subjects={noteSubjects}
          onClose={handleEditNoteClose}
          onSave={handleEditNoteSave}
        />
      )}

      {noteToastMessage ? (
        <NoteToast
          message={noteToastMessage}
          variant={noteToastVariant}
          onClose={() => setNoteToastMessage("")}
        />
      ) : null}
      {/* Share Popup */}
      {showSharePopup && (
        <div
          className="share-popup"
          style={{
            position: "absolute",
            top: sharePopupPos.top,
            left: sharePopupPos.left,
            zIndex: 9999,
          }}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {/* <p><strong>Share this article</strong></p> */}
          {/* <input type="text" value={shareUrl} readOnly /> */}

          <div className="share-buttons-social">
            {/* Copy Button */}
            <div onClick={handleCopy} style={{ cursor: "pointer" }}>
              <img
                src="/assets/images/copy-1.svg"
                alt="Copy link"
                width={30}
                height={30}
              />
            </div>

            {/* WhatsApp */}
            <div
              onClick={() => {
                const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                  shareUrl,
                )}`;
                window.open(whatsappUrl, "_blank");
              }}
            >
              <img
                src="/assets/images/whatsapp.svg"
                alt="Share on WhatsApp"
                width={30}
                height={30}
              />
            </div>

            {/* Telegram */}
            <div
              onClick={() => {
                const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(
                  shareUrl,
                )}&text=${encodeURIComponent(shareUrl)}`;
                window.open(telegramUrl, "_blank");
              }}
            >
              <img
                src="/assets/images/telegram.svg"
                alt="Share on Telegram"
                width={30}
                height={30}
              />
            </div>

            {/* Facebook */}
            <div
              onClick={() => {
                const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  shareUrl,
                )}`;
                window.open(facebookUrl, "_blank");
              }}
            >
              <img
                src="/assets/images/facebook.svg"
                alt="Share on Facebook"
                width={30}
                height={30}
              />
            </div>

            {/* LinkedIn */}
            <div
              onClick={() => {
                const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                  shareUrl,
                )}`;
                window.open(linkedInUrl, "_blank");
              }}
            >
              <img
                src="/assets/images/linkdine.svg"
                alt="Share on LinkedIn"
                width={30}
                height={30}
              />
            </div>

            {/* X (Twitter) */}
            <div
              onClick={() => {
                const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  shareUrl,
                )}`;
                window.open(twitterUrl, "_blank");
              }}
            >
              <img
                src="/assets/images/x.svg"
                alt="Share on X (Twitter)"
                width={30}
                height={30}
              />
            </div>

            {/* Close Button */}
            {/* <div onClick={() => setShowSharePopup(false)} className="clos-icon-pop">
    <img
      src="/assets/images/close.svg"
      alt="Close"
      width={30}
      height={30}
    />
  </div> */}
          </div>

          {copied && <p className="copy-msg">✅ Link copied!</p>}
        </div>
      )}
    </div>
  );
}

export default CurrentAffairs;
